import styled, { css } from "styled-components";

export const LargeTitle = styled.span`
  //styleName: xLarge (our default)/Large Title;
  font-family: "Lora";
  font-size: 36px;
  font-weight: 500;
  line-height: 45px;
  letter-spacing: -0.01em;
  text-align: left;
`;

export const Title1 = styled.span`
  //styleName: xLarge (our default)/Title 1;
  font-family: "Lora";
  font-size: 30px;
  font-weight: 500;
  line-height: 38px;
  letter-spacing: -0.01em;
  text-align: left;
`;

export const Title2 = styled.span`
  //styleName: xLarge (our default)/Title 2;
  font-family: "Lora";
  font-size: 24px;
  font-weight: 600;
  line-height: 30px;
  letter-spacing: -0.01em;
  text-align: left;
`;

export const Title3 = styled.span`
  //styleName: xLarge (our default)/Title 3;
  font-family: "Lora";
  font-size: 22px;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.01em;
  text-align: left;
`;

export const Headline = styled.span`
  //styleName: xLarge (our default)/Headline;
  font-family: "Inter";
  font-size: 19px;
  font-weight: 400;
  line-height: 23px;
  letter-spacing: 0em;
  text-align: left;
`;

export const Body = styled.p`
  //styleName: xLarge (our default)/Body;
  font-family: "Inter";
  font-size: 19px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  text-decoration: none;
  color: inherit;
`;

export const SpacingCss = css`
  margin-top: ${(props) =>
    props.spacing === "tight"
      ? css`.5em`
      : props.spacing === "loose"
        ? css`1em`
        : css`.75em`};
`;

export const MemoryContent = styled(Body)`
  margin-bottom: 20px;
  &,
  & * {
    overflow-wrap: break-word;
    max-width: 100%;
  }

  p {
    min-height: 1em;

    + p {
      ${SpacingCss}
    }
  }

  pre code {
    white-space: normal;
  }

  strong {
    font-weight: 700;
  }

  em {
    font-style: italic;
  }

  ul,
  ol {
    padding-left: 1.5em;
  }

  ul {
    list-style-type: disc;
  }

  ol {
    list-style-type: decimal;
  }

  blockquote {
    padding: 0.5em;
    border-left: 4px solid rgb(${(props) => props.theme.colors.neutral150});
  }
`;
export const Bold = styled.strong`
  //styleName: xLarge (our default)/Body-Bold;
  font-family: "Inter";
  font-size: 19px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
`;
export const Callout = styled.span`
  //styleName: xLarge (our default)/Callout;
  font-family: "Inter";
  font-size: 18px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
`;

export const Subhead = styled.span`
  //styleName: xLarge (our default)/Subhead;
  font-family: "Inter";
  font-size: 17px;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
`;

export const Footnote = styled.span`
  //styleName: xLarge (our default)/Footnote;
  font-family: "Inter";
  font-size: 15px;
  font-weight: 400;
  line-height: 15px;
  letter-spacing: 0em;
  text-align: left;
`;

export const Caption1 = styled.span`
  //styleName: xLarge (our default)/Caption 1;
  font-family: "Inter";
  font-size: 14px;
  font-weight: 500;
  line-height: 125%;
  letter-spacing: -0.05em;
  text-align: left;
`;

export const Caption2 = styled.span`
  //styleName: xLarge (our default)/Caption 2;
  font-family: "Inter";
  font-size: 13px;
  font-weight: 500;
  line-height: 125%;
  letter-spacing: -0.05em;
  text-align: left;
`;
export const Label = styled.span`
  /* Label */
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
`;
